import React from "react"
import { useParams } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Alert, Button, Col, Flex, Form, Input, Row, Typography } from "antd"
import { CopyOutlined } from "@ant-design/icons"

import { notify } from "@src/app/components/notify"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { GlobalFiatTopUp } from "@src/pages/depositFiat/classes/FiatTopUp"
import { DepositFiatInfoList } from "@src/pages/depositFiat/ui/DepositFiatInfoList"
import css from "./index.module.css"

export const DepositFiatPage = observer(() => {
  const { symbol } = useParams<{
    symbol: string
  }>()

  const store = GlobalFiatTopUp()
  const bankAccount = computed(() => {
    return store.accountByCurrency(symbol as string)
  }).get()

  const copy = (v: string) => {
    navigator.clipboard.writeText(v).then(() => notify.success("Copied"))
  }

  return (
    <DefaultPageLayout isLoading={store.isLoading} title={`Deposit ${symbol}`}>
      <>
        {bankAccount ? (
          <Row gutter={64} style={{ marginTop: 16, width: "100%" }}>
            <Col span={12}>
              <Flex gap={16} vertical>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  {bankAccount.name}
                </Typography.Title>
                <Form.Item
                  id="GENERATED_ID_DEPOSITFIAT_FORM_ITEM_VOID_1"
                  label="Copy unique code"
                  layout="vertical"
                >
                  <Input
                    addonAfter={
                      <Button
                        icon={<CopyOutlined />}
                        onClick={() => copy(bankAccount.ticker as string)}
                        size="small"
                        type="text"
                      />
                    }
                    className={css.input}
                    disabled
                    value={bankAccount.ticker ?? ""}
                  />
                </Form.Item>
                <Alert
                  message={
                    <Typography.Text>
                      Please enter your unique code "{bankAccount.ticker}" in
                      the Reference field when sending fiat from your corporate
                      bank account. This will help us process your deposit
                      faster <br /> Top-ups can only be made from a corporate
                      bank account of a company that has successfully completed
                      Know Your Business (KYB) verification during account
                      registration
                    </Typography.Text>
                  }
                  showIcon
                  style={{
                    backgroundColor: "white",
                    border: "unset",
                    boxShadow: `
                      0 6px 16px 0 rgb(0 0 0 / 8%),
                      0 3px 6px -4px rgb(0 0 0 / 12%),
                      0 9px 28px 8px rgb(0 0 0 / 5%)
                    `,
                  }}
                  type="warning"
                />
              </Flex>
            </Col>

            <Col span={12}>
              {bankAccount.details && (
                <DepositFiatInfoList
                  details={bankAccount.details}
                  feePercent={bankAccount.fee_percent}
                  symbol={symbol as string}
                />
              )}
            </Col>
          </Row>
        ) : (
          <Typography.Title level={1} style={{ textAlign: "center" }}>
            This service is temporarily unavailable
          </Typography.Title>
        )}
      </>
    </DefaultPageLayout>
  )
})
